export const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export function formatCLP(n) {
  return `$${Number(n || 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;
}

const pad = (n) => String(n).padStart(2, '0');

// Fecha de HOY en hora local (YYYY-MM-DD).
// No usar toISOString(): devuelve la fecha UTC, y en Chile después de las 20-21h ya es "mañana".
export function hoyISO() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function haceDiasISO(dias) {
  const d = new Date();
  d.setDate(d.getDate() - dias);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Convierte 'YYYY-MM-DD' en Date local (new Date('YYYY-MM-DD') lo interpreta como UTC y corre un día).
export function parseFecha(f) {
  if (!f) return null;
  const [y, m, d] = f.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatFecha(f) {
  if (!f) return '';
  const [y, m, d] = f.split('-');
  return `${d}/${m}/${y}`;
}

// Días desde hoy hasta la fecha (negativo = ya pasó).
export function diasHasta(f) {
  return Math.round((parseFecha(f) - parseFecha(hoyISO())) / 86400000);
}

export function claveMes(f) {
  return f ? f.slice(0, 7) : 'sin-fecha';
}

export function nombreMes(clave) {
  if (clave === 'sin-fecha') return 'Sin fecha';
  const [y, m] = clave.split('-');
  return `${MESES[Number(m) - 1]} ${y}`;
}

// Agrupa registros por mes (según el campo de fecha), del mes más reciente al más antiguo.
export function agruparPorMes(registros, campoFecha = 'fecha') {
  const grupos = {};
  registros.forEach(r => {
    const clave = claveMes(r[campoFecha]);
    (grupos[clave] = grupos[clave] || []).push(r);
  });
  return Object.keys(grupos)
    .sort((a, b) => b.localeCompare(a))
    .map(clave => ({
      clave,
      nombre: nombreMes(clave),
      registros: grupos[clave].sort((a, b) =>
        (b[campoFecha] || '').localeCompare(a[campoFecha] || '') ||
        (b.created_at || '').localeCompare(a.created_at || '')),
    }));
}
